export default __webpack_public_path__ + "img/icon-up-secondary.asset.0ada9426.png";